import { TranslatePipe } from "./translate.pipe";
import { VatNumberHintPipe } from "./vat-number-hint.pipe";

export const Pipes = [
	TranslatePipe,
	VatNumberHintPipe,
]
